import { render } from "./SpacesContactsAdd.vue?vue&type=template&id=a4da9bba&scoped=true&ts=true"
import script from "./SpacesContactsAdd.vue?vue&type=script&lang=ts"
export * from "./SpacesContactsAdd.vue?vue&type=script&lang=ts"

import "./SpacesContactsAdd.vue?vue&type=style&index=0&id=a4da9bba&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a4da9bba"]])

export default __exports__